module.exports = __webpack_public_path__ + "static/media/Tristana_0.3799feb2.jpg";